module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("kAoOI"))).then(() => parcelRequire('d0iPb'));